import { put } from "@redux-saga/core/effects";
import { push } from "connected-react-router";
import isOnline from "is-online";
// import Cookies from "js-cookie";
// import { getSavedContext } from '@/messenger/App';
import { Action } from "redux";
import { delay, select, spawn, takeEvery } from "redux-saga/effects";

import { REDIRECT_TO_LOGOUT_ACTION } from "@/messenger/actions/saga";
import { LOGOUT, LOGOUT_REDIRECT_PARAM } from "@/messenger/constants/routing";
import { customerSelector } from "@/messenger/ducks/entities/customers";
import { setIsOnlineAC } from "@/messenger/ducks/general/isOnline.duck";
import { setHideRingCentral } from "@/messenger/integration/RingCentral";

export interface TIntervalListnerPayload {
    customerLogoutUrl: string;
    federated: boolean;
    reason: string;
}
interface TIntervalListnerAction extends Action {
    type: string;
    payload: TIntervalListnerPayload;
}

const defaultContext = {
    customerLogoutUrl: "",
    federated: false,
    reason: "",
};

function* listenForOffline() {
    while (true) {
        yield delay(4000);

        const result = yield isOnline();

        if (!result) {
            let failuresToConnect = 0;
            let connectionResult = yield isOnline();
            while (!connectionResult && failuresToConnect < 3) {
                yield delay(1000);
                connectionResult = yield isOnline(); 
                    
                if (!connectionResult) {
                    failuresToConnect += 1;
                }
            }

            if (failuresToConnect === 3) {

                yield put(setIsOnlineAC(false));
                setHideRingCentral(true);
                return;
            }
        }
    }
}

function* redirectToLogout(action: TIntervalListnerPayload = defaultContext) {
    const customers = yield select(customerSelector.selectAll);
    if (customers) {}

    const context = action;
    const origin = `${window.location.origin}/login`;

    // const context:any = getSavedContext();
    // const hasCustomLogout = context?.logoutUrl;

    // when no custom logout url is set
    let url = `/${LOGOUT}?${LOGOUT_REDIRECT_PARAM}=${origin}`;
    
    // when custom url is set
    if (context?.federated && context?.customerLogoutUrl) {
        url = `/${LOGOUT}?federated&${LOGOUT_REDIRECT_PARAM}=${context?.customerLogoutUrl}&reason=${context?.reason}`;
    } else if (!context?.federated && context?.customerLogoutUrl){
        url = `/${LOGOUT}?${LOGOUT_REDIRECT_PARAM}=${context?.customerLogoutUrl}&reason=${context?.reason}`;
    }
    yield put(push(url));

    // if (hasCustomLogout && context['federated'] === true) {
        // yield put(push(`/${LOGOUT}?federated&${LOGOUT_REDIRECT_PARAM}=${context.logoutUrl}`));
    // } else if (hasCustomLogout && context['federated'] !== true) {
    //     yield put(push(`/${LOGOUT}?${LOGOUT_REDIRECT_PARAM}=${context.logoutUrl}`));
    // } else {
    //     yield put(push(`/${LOGOUT}`));
    // }  
}

function* redirectToLogoutListener(action: TIntervalListnerAction){
    yield redirectToLogout(action.payload);
}

// function* listenForLogout() {
//     while(true) {
//         yield delay(3000);
//         const authCookieKey = Object.keys(Cookies.get()).filter(key => key.endsWith(".is.authenticated"))[0];
//         const authCookie = authCookieKey ? Cookies.get(authCookieKey) : null;
//         if(!authCookie) {
//             yield redirectToLogout();
//             return;
//         }
//     }
// }

export default function* intervalListenerSaga() {
    yield spawn(listenForOffline);
    // yield spawn(listenForLogout);
    yield takeEvery(REDIRECT_TO_LOGOUT_ACTION, redirectToLogoutListener);
}
